import { Navigate, Route, Routes, useLocation } from "react-router-dom";
// import Nprogress from "nprogress";
// import "nprogress/nprogress.css";
import Layout from "./common/components/Layout";
import Modal from "./common/components/Layout/Modal";
import routes from "./common/routes";
import { generateRoute } from "./common/routes/generateRoute";
import route from "./common/routes/route";
import ErrorPage from "./module/settings/pages/Error";
import NProgressBar from "./common/components/NprogessBar";


function App() {
  const location = useLocation();
  const background = location.state && location.state.background;
  return (
    <>
      <NProgressBar />
      <Routes location={background || location}>
        <Route element={<Layout />}>
          {route.map((component) => generateRoute(component))}
        </Route>
        <Route
          path="/"
          element={<Navigate to={routes.protected.dashboard} />}
        />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      {background && <Modal />}
    </>
  );
}

export default App;
